import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { ServidorProvider } from '../../servidor/servidor';
import { timeout, catchError } from 'rxjs/operators';


export abstract class HttpServidor {

    constructor(protected http: HttpClient) {}
    
    protected montarURL(nomeDoMetodo: string): string {
        return `${ServidorProvider.getUrlChamadaServidor()}/${nomeDoMetodo}`;
    }

    protected get<T>(nomeMetodo: string, form: HttpParams | {[param: string]: string | string[]}): Observable<T> {
        return new Observable<T>(
            observer => {
                const url = this.montarURL(nomeMetodo);//timeout(15000).catch(err => {return Observable.throw('Tempo limite excedido.')})
                this.http.get(url, {headers: {}, params: form}).subscribe(
                    (res: any) => {
                        if (res.ok) {
                            observer.next(res.result);
                        } else {
                            observer.error(res.msg);
                        }
                    }, (error) => {
                        observer.error(error);
                    }, () => {
                        observer.complete();
                    }
                )
            }
        )
    }

    protected post<T>(nomeMetodo: string, form: FormData): Observable<T> {
        return new Observable<T>(
            observer => {
                const url = this.montarURL(nomeMetodo); //timeout(15000).catch(err => {return Observable.throw('Tempo limite excedido.')})
                this.http.post(url, form, {headers: {}}).subscribe(
                    (res: any) => {
                        if (res.ok) {
                            observer.next(res.result);
                        } else {
                            observer.error(res.msg);
                        }
                    }, (error) => {
                        observer.error(error);
                    }, () => {
                        observer.complete();
                    }
                )
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/providers/shared/abstract/http-servidor.ts